/**
 * Official UTMify tracking scripts.
 * Loaded once on app start from index.tsx via loadUtmify().
 */

const UTM_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
const PIXEL_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'

/**
 * UTMify pixel id. The pixel script REQUIRES window.pixelId to be defined before
 * it loads — without it, it throws internally ("lead._id" of undefined).
 * Paste your UTMify pixel id here to enable the pixel; leave empty to load
 * only the UTM parameter tracking script.
 */
const UTMIFY_PIXEL_ID = ''

declare global {
  interface Window {
    pixelId?: string
  }
}

let loaded = false

export function loadUtmify(): void {
  if (loaded || typeof document === 'undefined') return
  loaded = true

  // UTM parameter tracking (works standalone, no id required)
  if (!document.querySelector(`script[src="${UTM_SCRIPT_SRC}"]`)) {
    const utmScript = document.createElement('script')
    utmScript.src = UTM_SCRIPT_SRC
    utmScript.async = true
    utmScript.defer = true
    utmScript.setAttribute('data-utmify-prevent-xcod-sck', '')
    utmScript.setAttribute('data-utmify-prevent-subid', '')
    document.head.appendChild(utmScript)
  }

  // UTMify pixel — only loaded when a pixel id is configured
  if (!UTMIFY_PIXEL_ID) return

  window.pixelId = UTMIFY_PIXEL_ID

  if (!document.querySelector(`script[src="${PIXEL_SCRIPT_SRC}"]`)) {
    const pixelScript = document.createElement('script')
    pixelScript.src = PIXEL_SCRIPT_SRC
    pixelScript.async = true
    pixelScript.defer = true
    document.head.appendChild(pixelScript)
  }
}
